import { render } from "./SeatList.vue?vue&type=template&id=2a05cb4e&scoped=true"
import script from "./SeatList.vue?vue&type=script&lang=js"
export * from "./SeatList.vue?vue&type=script&lang=js"

import "./SeatList.vue?vue&type=style&index=0&id=2a05cb4e&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a05cb4e"]])

export default __exports__